import React from "react";
import Template from "./template";

function VideoListingComponent({ listing = [] }) {
  return Array.isArray(listing)
    ? listing.map((value, index) => <Template listing={value} key={index} />)
    : null;
}

export { VideoListingComponent };
